<template>
  <PreLifeDashboard
    :display-pre-life="!restrictPreLifeAccess"
    :is-mobile="$q.screen.xs"
    :display-quotes="hasAnyQuote && !acceptedQuoteId"
    :display-quote-stepper="
      Boolean(!hasAnyQuote || (acceptedQuoteId && !hasSettlement))
    "
    :settlement-loading="settlementLoading"
    :has-quote-loading="hasQuoteLoading"
    :quotes="quotesOrderedByAccepted"
    :completed-quote="acceptedQuoteId"
    :quotes-errors="quotesErrors"
    :quotes-loading="quotesLoading"
    :org-contact-phone="theme().novatedBrand?.support?.phone"
    :display-settlement="hasSettlement && !hasSettlementCompleted"
    :images="images"
    @open:quote="goToQuoteDecision"
  />
</template>

<script>
import { getAsset, getEnv } from 'ecx.saigon.ui.common';
import { mapGetters, mapState, mapActions } from 'vuex';
import { mountSettlementWidget } from 'ecx.saigon.ui.settlement';
import { profileCompleteGuard } from '@/utils/profile-complete-guard';
import { getDocusignUrl } from '../../api/settlement';

export default {
  name: 'PreLifeWidget',
  data() {
    return {
      images: {}
    };
  },
  computed: {
    ...mapState({
      quotes: (state) => state.dashboard.quotes,
      quotesLoading: (state) => state.dashboard.quotesLoading,
      quotesErrors: (state) => state.dashboard.quotesErrors,
      settlementLoading: (state) => state.settlement.settlementLoading,
      user: (state) => state.user.user,
      application: (state) => state.application.application || {},
      settlement: (state) => state.settlement.settlement
    }),
    ...mapGetters('application', [
      'applicationComplete',
      'hasAnyQuote',
      'hasSettlement',
      'acceptedQuoteId',
      'applicationQuoteIDs',
      'creditCheckComplete'
    ]),
    ...mapGetters('dashboard', ['hasQuoteLoading']),
    ...mapGetters('user', [
      'theme',
      'restrictPreLifeAccess',
      'userIsAccessLevel'
    ]),
    ...mapGetters('settlement', ['hasSettlementCompleted']),
    ...mapGetters('lease', ['hasLeases']),
    quotesOrderedByAccepted() {
      const acceptedId = this.acceptedQuoteId;
      const unsortedQuotes = Object.values(this.quotes);
      if (!acceptedId || !unsortedQuotes.length) {
        return unsortedQuotes;
      }
      const clone = { ...this.quotes };
      if (!clone[acceptedId]) {
        return Object.values(clone);
      }
      let sortedByAccepted = [clone[acceptedId]];
      delete clone[acceptedId];
      sortedByAccepted = sortedByAccepted.concat(Object.values(clone));
      return sortedByAccepted;
    }
  },
  methods: {
    ...mapActions('application', ['getApplication']),
    ...mapActions('dashboard', ['getQuotes']),
    ...mapActions('settlement', ['getSettlement']),
    async createQuote() {
      const env = await getEnv();
      if (profileCompleteGuard(this)) {
        window.location = env.VUE_APP_QUOTE_ROUTE;
      }
    },
    async goToQuoteDecision(quote) {
      const env = await getEnv();
      if (profileCompleteGuard(this)) {
        return (window.location = `${env.VUE_APP_QUOTE_ROUTE}/${quote.quoteId}/summary`);
      }
    },
    async getDashboardData() {
      if (this.restrictPreLifeAccess) {
        return;
      }

      if (this.acceptedQuoteId) {
        await this.getQuotes([this.acceptedQuoteId]);
      } else {
        await this.getQuotes(this.applicationQuoteIDs);
      }

      if (this.hasSettlement) {
        if (!this.settlement.orderId) {
          await this.getSettlement(this.acceptedQuoteId);
        }
        if (!this.hasSettlementCompleted) {
          await mountSettlementWidget({
            mountSelector: '#settlement-app',
            user: this.user,
            application: this.application,
            quote: this.quotes[this.acceptedQuoteId],
            settlement: this.settlement,
            actions: {
              onCallDocusign: getDocusignUrl
            }
          });
        }
      }
    }
  },
  async mounted() {
    this.images = {
      ...this.images,
      quoteError: await getAsset(this.$Constants.VEHICLE_ERROR_IMG_PATH)
    };
    await this.getDashboardData();
  },
  components: {
    PreLifeDashboard: () =>
      import('../../components/organism/pre-life-dashboard')
  }
};
</script>
